import React from 'react'
import PropTypes from 'prop-types'
import styles from './heading.module.css'
import cs from 'classnames'

export const H1 = 'h1'
export const H2 = 'h2'
export const H3 = 'h3'
export const H4 = 'h4'
export const H5 = 'h5'
export const H6 = 'h6'

const Heading = ({
  className,
  text,
  Element = H1,
  centerAlign,
  capitalize = false,
  bold = false,
}) => (
  <Element
    className={cs(
      styles.container,
      bold && styles.bold,
      centerAlign && styles.centerAlign,
      capitalize && styles.capitalize,
      className,
    )}
  >
    {text}
  </Element>
)

Heading.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  Element: PropTypes.string,
  centerAlign: PropTypes.bool,
  capitalize: PropTypes.bool,
  className: PropTypes.string,
  bold: PropTypes.bool,
}

export default Heading
